import { useStation } from '../../../core/stations/hooks/useStation';
import { useStations } from '../../../core/stations/hooks/useStations';

export function useDescriptionFooters(stationId: string) {
  const station = useStation(stationId);

  return station.featuresConfig?.fragments?.descriptionFooters || [];
}

export function useAllStationsDescriptionFooters() {
  const stations = useStations();
  return stations.map((station) => station.featuresConfig?.fragments?.descriptionFooters || []);
}
